import classNames from 'classnames';
import React from 'react';

type Props = {
  id: string,
  className?: string,
  iconClassName?: string,
  selected: boolean,
  tabIndex: number,
  label: string,

  onSelect: (tabIndex: number) => void
};

class NavTab extends React.PureComponent<Props> {
  constructor (props: Props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect () {
    const { tabIndex, onSelect } = this.props;
    onSelect(tabIndex);
  }

  override render (): React.ReactNode {
    const { id, className, iconClassName, selected, label } = this.props;

    const liClassName = classNames(
      className,
      {'active': selected}
    );
    return (
      <li role='presentation' className={liClassName}>
        <a id={id} role='button' onClick={this.handleSelect}>
          <div className='esko_tablabel'>
            { iconClassName && <div className={iconClassName} /> }
            { iconClassName ? <span className='esko_tablabel_icon'>{label}</span> : <div>{label}</div>}
          </div>
        </a>
      </li>
    );
  }
}

export default NavTab;
